import React, { useRef, useEffect } from "react";
import cx from "classnames";
import { resizeIFrame } from "utils/resizeIFrame";
import styles from "./IFrame.module.scss";

type IFrameProps = React.IframeHTMLAttributes<HTMLIFrameElement> & {
  src: string;
  width: string;
  height: string;
  title: string;
  className?: string;
};

const IFrame = ({ src, width, height, title, className }: IFrameProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null!);
  let padding: undefined | number;
  // check if width and height are integers, not percentages
  if (+width && +height) {
    padding = (+height / +width) * 100;
  }

  useEffect(() => {
    const { current } = iframeRef;
    current && resizeIFrame(current);
  }, [iframeRef]);

  return (
    <>
      {padding ? (
        <div
          className={cx(styles.responsiveWrapper, "embed-wrapper")}
          style={{ paddingBottom: `${padding}%` }}
        >
          <iframe
            ref={iframeRef}
            className={cx(styles.responsiveIFrame, className)}
            src={src}
            width={width}
            height={height}
            title={title}
            allowFullScreen={true}
            frameBorder="0"
            scrolling="no"
          />
        </div>
      ) : (
        <iframe
          ref={iframeRef}
          className={className}
          src={src}
          width={width}
          height={height}
          title={title}
          allowFullScreen={true}
          frameBorder="0"
          scrolling="no"
        />
      )}
    </>
  );
};

export default IFrame;
